import Phaser from 'phaser';
import { assetManifest } from '../../content/assets';
import { getGameRuntime } from '../runtime';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('Preload');
  }

  preload(): void {
    const { events } = getGameRuntime();
    this.load.on('progress', (progress: number) => events.emit('loading:progress', { progress }));
    this.load.on('loaderror', (file: { key: string; src: string }) => {
      console.warn(`Asset kunne ikke indlæses: ${file.key} (${file.src}). Phaser-fallback bruges.`);
    });

    for (const asset of Object.values(assetManifest)) {
      if (asset.type === 'image') this.load.image(asset.id, asset.path);
    }
  }

  create(): void {
    this.#ensureFallbackTexture('map-background', 1920, 1080, 0x17364a);
    this.#ensureFallbackTexture('soldaterboegen-background', 1920, 1080, 0x34513d);
    this.#ensureFallbackTexture('knife-icon', 240, 120, 0xd7ad64);
    this.#ensureFallbackTexture('raadhustorvet-background', 1920, 1080, 0x8f7960);
    this.#ensureFallbackTexture('grain-sack-icon', 270, 310, 0xb69b6a);
    this.scene.start('VejleMap');
  }

  #ensureFallbackTexture(key: string, width: number, height: number, color: number): void {
    if (this.textures.exists(key)) return;
    const graphics = this.make.graphics({ x: 0, y: 0 }, false);
    graphics.fillStyle(color).fillRect(0, 0, width, height);
    graphics.lineStyle(12, 0xf5c45e).strokeRect(6, 6, width - 12, height - 12);
    graphics.generateTexture(key, width, height);
    graphics.destroy();
  }
}
